export const CHECK_INTERVAL = 5000;
export const FETCH_INTERVAL = 10000; // 10 seconds
export const REDIRECT_PATH = '/';
export const IP_CACHE_KEY = 'user_ip';
export const IP_CACHE_TIMESTAMP_KEY = 'user_ip_timestamp';
export const IP_CACHE_DURATION = 60 * 60 * 1000;
